import { BottomBarModal, Button } from 'component';
import { useState } from 'react';
import { orderDataSlice } from 'state/orderSlice';
import { useAppDispatch } from 'state/store';
import './NewTakeoutModal.css';

export default function NewTakeoutModal({ onClose }: { onClose: () => void }) {
    // TODO: remove default values
    const [firstName, setFirstName] = useState('James');
    const [lastName, setLastName] = useState('Grup');
    const dispatch = useAppDispatch();

    const leftButtons = [<Button key="cancel" text={'Cancel'} onClick={onClose} />];

    const validInput = firstName && lastName;
    const addItemsOnClick = () => {
        if (validInput) {
            dispatch(orderDataSlice.actions.startTakeoutOrder({ firstName, lastName }));
            onClose();
        }
    };
    const rightButtons = [
        <Button key="addItems" text={'Add Items'} onClick={addItemsOnClick} disabled={!validInput} />,
    ];

    return (
        <BottomBarModal onClose={onClose} leftContent={leftButtons} rightContent={rightButtons}>
            <div className="NewTakeoutModalContent">
                <div className="NewTakeoutModalInputRow">
                    <div>Name:</div>
                    <input
                        className="NewTakeoutModalInput"
                        onChange={(event) => setFirstName(event.target.value)}
                        value={firstName}
                    />
                    <input
                        className="NewTakeoutModalInput"
                        onChange={(event) => setLastName(event.target.value)}
                        value={lastName}
                    />
                </div>
            </div>
        </BottomBarModal>
    );
}
